export default {
  "content": "<path d=\"M10.996 5.516C7.614 5.503 4.5 8.738 4.5 12.5a7 7 0 007 7c3.762 0 6.997-3.114 6.984-6.496l2-.008c.018 4.617-4.246 8.504-8.984 8.504a9 9 0 01-9-9c0-4.738 3.887-9.002 8.504-8.984l-.008 2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 2a8 8 0 018 8 1 1 0 01-1 1h-7a1 1 0 01-1-1V3a1 1 0 011-1zm1 7h4.915A6.002 6.002 0 0015 4.084V9z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};